import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import CloudUpload from '@material-ui/icons/CloudUpload';
import Close from '@material-ui/icons/Close';

const UploadPad = ({ dropHandler, acceptedFileTypes, closeHandler, maxSize }) => (
  <Dropzone className="attachment" onDrop={dropHandler} accept={acceptedFileTypes} maxSize={maxSize}>
    <CloudUpload className="icon large-icon" />
    <br />
    Drag and drop documents or <span className="action-link">browse</span>
    {closeHandler && (
      <nav className="nav-bar">
        <Close className="icon md" onClick={closeHandler} />
      </nav>
    )}
  </Dropzone>
);

UploadPad.propTypes = {
  dropHandler: PropTypes.func.isRequired,
  acceptedFileTypes: PropTypes.string,
  closeHandler: PropTypes.func,
};

export default UploadPad;
